/* Выполняется первым и без импортов: keycloakAuth парсит localStorage.AUTH при инициализации модуля. */

const AUTH_KEY = 'AUTH';

const CORRUPT_AUTH_PLACEHOLDER = '{"sp_auth_corrupt":1}';

function sanitizeAuthStorage(): void {
    let raw: string | null = null;
    try {
        raw = window.localStorage.getItem(AUTH_KEY);
    } catch (e) {
        return;
    }
    if (!raw) { return; }

    let broken = false;
    let parsed: any = null;
    try {
        parsed = JSON.parse(raw);
    } catch (e) {
        broken = true;
    }
    if (!broken && (parsed === null || typeof parsed !== 'object')) {
        broken = true;
    }
    if (!broken) { return; }

    try {
        window.localStorage.setItem(AUTH_KEY, CORRUPT_AUTH_PLACEHOLDER);
    } catch (e) {
        try {
            window.localStorage.removeItem(AUTH_KEY);
        } catch (e2) {  }
    }

    // tslint:disable-next-line:no-console
    console.error(
        '[session-bootstrap] localStorage.AUTH содержал нечитаемое значение и заменён'
        + ' заглушкой. Приложение уведёт на форму входа с причиной AUTH_STORAGE_CORRUPT.',
    );
}

sanitizeAuthStorage();
